<template>
  <router-view></router-view>
</template>

<script setup></script>

<style>
  #app{
    margin: 0;
    padding: 0;
    width: 100vw;
    height: 100vh;
    font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: transparent;
    font-size: 14px;
    overflow: hidden;
    position: relative;
  }
  .radio-blue-border >>> .el-radio__inner {
    border-color: blue;
  }

  /* 强制选中状态为默认蓝色 */
  .radio-blue-border.is-checked >>> .el-radio__inner {
    border-color: #409EFF !important;
    background-color: #409EFF !important;
  }
</style>
